<template>
	<div class="">
		<div class="card-style-container" v-if="showButtonLayout">
			<div class="radio-button-container ">
				<div class="radio-button-option button-layout-wrapper">
					<input class="radio-button-input" type="radio" id="button" value="button" v-model="value.button.layout" />
					<label class="radio-button-label" for="button">
						{{ $t('Button') }}
					</label>
				</div>
				<div class="radio-button-option button-layout-wrapper">
					<input class="radio-button-input" type="radio" id="callout" value="callout" v-model="value.button.layout" />
					<label class="radio-button-label" for="callout">
						{{ $t('Callout') }}
					</label>
				</div>
				<div class="radio-button-option button-layout-wrapper" v-if="showPreview">
					<input class="radio-button-input" type="radio" id="proview" value="preview" v-model="value.button.layout" />
					<label class="radio-button-label" for="proview">
						{{ $t('Preview') }}
					</label>
				</div>
			</div>

			<div class="preview-container">
				<ButtonPreview
					class="button-preview-container"
					:config="value.button"
					:user="user"
					:type="value.button.type"
					:showCallout="false"
					:product="value.product"
				/>
			</div>
		</div>
		<template>
			<AppInput
				class="form-group mb-3 pb-2"
				:class="{ 'form-error': validation.product.title.$error }"
				label="Add a title"
				maxlength="50"
				placeholder="Title Here..."
				v-model="value.product.title"
				required=""
			/>
			<div v-if="['callout', 'preview'].includes(value.button.layout)">
				<AppInput
					class="form-group mb-3 pb-2"
					:label="$t('Description')"
					maxlength="100"
					:placeholder="$t('Enter a description for your followers here')"
					v-model="value.button.tagline"
				/>
				<AppInput
					class="form-group mb-3 pb-2"
					:class="{ 'form-error': validation.button.button_text.$error }"
					label="Button"
					:key="value.button.layout"
					maxlength="30"
					placeholder="Button Text Here..."
					v-model="value.button.button_text"
				/>
			</div>
		</template>
		<template>
			<div class="group-heading">Add a thumbnail</div>
			<FileDropZone
				:image="value.button.image"
				:userflowKey="userflowKey"
				class="new file-drop-zone"
				drop-zone-class="header-image-drop-zone"
				drop-zone-placeholder="Thumbnail"
				expected-dimension="400x400"
				@start-upload="payload => $emit('start-upload', payload)"
				@uploaded="payload => $emit('imageUploaded', payload)"
				@uploaded-all="payload => $emit('uploaded-all', payload)"
				@delete-file="payload => $emit('delete-file', payload)"
				@cancel-file="payload => $emit('cancel-file', payload)"
				data-test-id="upload-button-file-button"
				:crop-aspect-ratio="1"
				accept="image"
			/>
		</template>
	</div>
</template>
<script>
	import { mapGetters } from 'vuex'
	import FileDropZone from '~/components/uploads/FileDropZone'
	import ButtonPreview from '~/pages/stores/components/ButtonPreview'

	export default {
		name: 'PageButtonFormStepped',
		props: {
			value: {
				type: Object,
				default: () => {},
			},
			validation: {
				type: Object,
				default: () => {},
			},
			showButtonLayout: {
				type: Boolean,
				default: true,
			},
			userflowKey: {
				type: String,
				default: '',
			},
		},
		data() {
			return {}
		},
		components: {
			FileDropZone,
			ButtonPreview,
		},
		computed: {
			...mapGetters('Auth', ['user']),
			root() {
				return this.showButtonLayout ? 1 : 0
			},
			showPreview() {
				return ['meeting', 'webinar', 'course', 'digital-download'].includes(this.$route.params.slug)
			},
			hasNamesOnProductsConsistent() {
				return this.user.experiments.names_on_products_consistent
			},
			buttonTitle() {
				return this.hasNamesOnProductsConsistent && !['callout', 'preview'].includes(this.value.button.layout) ? 'Title*' : 'Button*'
			},
		},
	}
</script>

<style lang="scss" scoped>
	.card-style-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		border-radius: 8px;
		border: 1px solid #e4e8fb;
		padding: 16px;
		margin-bottom: 20px;
		gap: 12px;

		.radio-button-container {
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			gap: 12px;
		}

		.preview-container {
			display: flex;

			.button-preview-container {
				width: 100%;
				height: auto;
				min-height: unset !important;
			}
		}
	}

	.button-layout-wrapper {
		display: flex;
		align-items: center;
		gap: 20px;
		input[type='radio'] {
			display: none;
		}
		label {
			display: flex;
			align-items: center;
			gap: 10px;
			position: relative;
		}
		label::before {
			content: '';
			width: 20px;
			height: 20px;
			border: 2px solid var(--stan-gray-dark-color);
			padding: 2px;
			border-radius: 50%;
			flex: 0 0 auto;
		}
		label::after {
			content: '';
			width: 10px;
			height: 10px;
			position: absolute;
			left: 5px;
			background-color: var(--stan-white);
			padding: 1px;
			border-radius: 50%;
		}
		input:checked + label::before {
			border: 2px solid var(--stan-primary-primary-color);
		}
		input:checked + label::after {
			background-color: var(--stan-primary-primary-color);
		}
	}

	.group-heading {
		font-weight: 600;
		font-size: 14px;
		line-height: 18px;
		letter-spacing: -2%;
		margin-bottom: 8px;
	}

	// override file-drop-zone component
	.file-drop-zone::v-deep {
		padding-top: 0 !important;

		.common-file-drop-zone {
			background-color: #f5f5f5 !important;
			border-width: 0 !important;

			.close-btn {
				display: none !important;
			}

			.file-drop-zone {
				padding-right: 22px;
			}
		}
	}
</style>
